var map = {
	"./Returns.json": 93801,
	"./SustainabilityFabrics.json": 49191,
	"./SustainabilityMain.json": 21372,
	"./SustainabilityOurApproach.json": 79928,
	"./SustainabilityPeople.json": 13122,
	"./SustainabilityPlanet.json": 14403,
	"./SustainabilityReport.json": 68945,
	"./SustainabilitySourcing.json": 10422,
	"./journal/a-state-of-bliss.json": 99874,
	"./journal/amberly-valentines-guide-to-bali.json": 66068,
	"./journal/an-endless-love-affair-with-the-sun.json": 5733,
	"./journal/an-insiders-guide-to-cape-town.json": 28410,
	"./journal/an-insiders-guide-to-florence.json": 46446,
	"./journal/animal-spirit.json": 76530,
	"./journal/city-escapes-insiders-travel-guide.json": 89870,
	"./journal/dania-macias-the-model-and-musician.json": 55325,
	"./journal/double-exposure.json": 76869,
	"./journal/how-we-pack-valentina-stephanie.json": 76814,
	"./journal/london-calling.json": 72604,
	"./journal/maja-weyhe.json": 31482,
	"./journal/muse-leyla-fischer.json": 99574,
	"./journal/rafael-mouras-guide-to-rio.json": 25779,
	"./journal/rhythm-of-the-sun.json": 82630,
	"./journal/sarah-qs-guide-to-ibiza.json": 41830,
	"./journal/sofia-el-arabi-travel-guide-morocco.json": 61722,
	"./journal/style-notes-the-ultimate-capsule-wardrobe.json": 22392,
	"./journal/taisia-and-raffo-in-the-amalfi-coast.json": 24966,
	"./journal/tastemaker-amberly-valentine.json": 29080,
	"./journal/tastemaker-mikkel-kristensen.json": 15377,
	"./journal/tastemaker-photgrapher-aaron-feaver.json": 45368,
	"./journal/the-magic-of-mexico.json": 15178,
	"./journal/the-muse-andrea-ricci.json": 84292,
	"./journal/the-muse-louise-lea-meylan.json": 69610,
	"./journal/the-muse-nina-urgell-cloquell.json": 97237,
	"./journal/the-muse-raissa-leme.json": 59828,
	"./journal/the-tastemaker-catherine-lomedico.json": 49115,
	"./journal/the-tastemaker-cristina-mantas.json": 51377,
	"./journal/the-tastemaker-fabio-napolitano.json": 71220,
	"./journal/the-tastemaker-felix-ruiz-diez.json": 55308,
	"./journal/the-tastemaker-nadine-koupaei.json": 3221,
	"./journal/the-tastemaker-prashant-ashoka-casa-eterea.json": 62751,
	"./journal/travel-sicily-taisia-darieva-raffo-marone.json": 82574,
	"./journal/typography-test.json": 43811,
	"./journal/valentina-and-stephanies-guide-to-london.json": 76777,
	"./journal/xiayan-guos-guide-to-paris.json": 24757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58041;